import { IPayload } from 'models/Global'
import {
  IGetUserAchievementsParams,
  IUserAchievement,
} from 'models/UserAchievements'
import { AxiosService } from 'network/config/config'
import { Endpoints } from 'network/config/endpoints'

export class UserAchievementsApi {
  constructor(private axios: AxiosService) {}

  getUserAchievements = async (params?: IGetUserAchievementsParams) => {
    const response = await this.axios.get<IPayload<IUserAchievement[]>>(
      Endpoints.getUserAchievements,
      params,
    )
    return response
  }
}
